import React from 'react';
import { Sidebar, type SidebarKey } from './Sidebar';
import { Topbar } from './Topbar';

interface AppShellProps {
    active: SidebarKey;
    onNavigate: (key: SidebarKey) => void;
    children: React.ReactNode;
}

export const AppShell: React.FC<AppShellProps> = ({ active, onNavigate, children }) => {
    return (
        <div className="flex h-screen w-full overflow-hidden bg-mapper-bg">
            <Sidebar active={active} onNavigate={onNavigate} />
            <div className="flex-1 flex flex-col min-w-0">
                <Topbar />
                <main className="flex-1 overflow-y-auto">
                    {children}
                </main>
            </div>
        </div>
    );
};
